<template>
      <div id="wrapper">
      <topbar></topbar>
      <!-- Top Bar End -->


      <!-- ========== Left Sidebar Start ========== -->

      <!-- Left Sidebar End -->
      <left></left>

      <div class="content-page">
            <!-- Start content -->
            <div class="content">
                  <div class="container-fluid">

                        <div class="row">
                              <div class="col-12">
                                    <div class="page-title-box">
                                          <!--
                                          <h4 class="page-title float-left">CPWM</h4>

                                          <ol class="breadcrumb float-right">
                                                <li class="breadcrumb-item"><a href="#">cpwm</a></li>
                                                <li class="breadcrumb-item"><a href="#">认证专区</a></li>
                                          </ol>
                                          -->
                                          <div class="clearfix"></div>
                                    </div>
                              </div>
                        </div>
                        <!-- end row -->


                        <div class="row">
                              <div class="col-md-12">
                                    <div class="card-box">
                                          <div class="row">
                                                <div class="col-12">


                                                      <h3 v-html="key" style="line-height: 56px;"></h3>
                                                      <p class="text-muted" style="display: none"></p>

                                                      <div class="clearfix"></div>


                                                </div>

                                          </div>


                                          <!-- end row -->

                                    </div>
                              </div>

                        </div>
                        <!-- end row -->


                  </div> <!-- container -->

            </div> <!-- content -->

            <!--footer-->

      </div>
      </div>

</template>

<script>
      import topbar from './topbar';
      import left from './left';
      export default {
            name: 'main',
            components:{topbar,left},
            data() {
                  return {
                        key:this.$route.query.key,
                  }
            },
            mounted(){
                  if(this.key==1){
                        this.key='您的特许私人财富管理师（CPWM<sup>&#174;</sup>）专属证书开始制作中，请耐心等待。';
                  }
                  if(this.key==2){
                        this.key='恭喜您！您已完成首次认证，成为CPWM<sup>&#174;</sup>持证人。请进入“再认证”专区，完成继续教育。'
                  }
                  if(this.key==3){
                        this.key='您的特许私人财富管理师（CPWM<sup>&#174;</sup>）专属名片开始制作中，请耐心等待。'
                  }
                  if(this.key==4){
                        this.key='恭喜您！您已完成特许私人财富管理师（CPWM<sup>&#174;</sup>）会员资格再认证。会员资格的有效期为2年，会员须在有效期内完成继续教育和再认证事项。'
                  }
                  if(this.key==5){
                        this.key='您参加的特许私人财富管理师（CPWM<sup>&#174;</sup>）认证课程培训合格的有效期已过期，请重新参加授权机构的培训，获得结业证明后，再次报名参加认证考试。'
                  }
                  if(this.key==6){
                        this.key='您尚未通过特许私人财富管理师 （CPWM<sup>&#174;</sup>）认证考试，目前您还不能申请首次认证。'
                  }
                  if(this.key==7){
                        this.key='您已完成首次认证，成为特许私人财富管理师（CPWM<sup>&#174;</sup>）持证人。CPWM<sup>&#174;</sup>持证人将成为CPWM<sup>&#174;</sup>协会会员，会员资格有效期为2年。'
                  }
                  if(this.key==8){
                        this.key='您尚未通过特许私人财富管理师（CPWM<sup>&#174;</sup>）首次认证，目前您还不能申请再认证。'
                  }
                  if(this.key==9){
                        this.key='您的特许私人财富管理师（CPWM<sup>&#174;</sup>）再认证资格已过期。因您未在规定时间内完成再认证，您的持证资格已被取消。如需重新持证，请参加授权机构的培训。'
                  }
                  if(this.key==10){
                        this.key='您的特许私人财富管理师（CPWM<sup>&#174;</sup>）首次认证资格已过期。请在培训合格有效期内重新报名参加认证考试。'
                  }
                  if(this.key==11){
                        this.key='您参加的特许私人财富管理师（CPWM<sup>&#174;</sup>）认证课程培训合格的有效期已过期，请重新参加授权机构的培训，获得结业证明后，再次报名参加认证考试。'
                  }
              if(this.key==12){
                this.key='您好！特许私人财富管理师（CPWM<sup>&#174;</sup>）再认证资格申请需在有效期到期前3个月提交，您还未到申请提交时间。'
              }
              if(this.key==13){
                this.key='您已完成首次认证，成为特许私人财富管理师（CPWM<sup>&#174;</sup>）持证人。CPWM<sup>&#174;</sup>持证人将成为CPWM<sup>&#174;</sup>协会会员，会员资格有效期为2年。'
              }
              if(this.key==14){
                this.key='您的特许私人财富管理师（CPWM<sup>&#174;</sup>）首次认证资格已过期。请重新报名参加认证考试，待考试通过后，再次提交认证申请。'
              }
              if(this.key==15){
                this.key='您参加的特许私人财富管理师（CPWM<sup>&#174;</sup>）认证课程培训合格的有效期已过期，请重新参加授权机构的培训，获得结业证明后，再次报名参加认证考试。'
              }

            },
            methods: {

                  //method over

            }
            //mounted over


      }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
      .zx{width:100%;}
      .zx li{width:100%;float: left}



</style>



// WEBPACK FOOTER //
// src/components/Authentication_show.vue